import React from 'react';
import { Modal, Spin } from 'antd';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import _ from 'lodash';

export default function PrintModal({
	openModal,
	closeModal,
	modalLoading,
	fileURL,
	modalTitle
}) {
	let { width, height } = useWindowDimensions();
	return (
		<>
			<Modal
				open={openModal}
				onCancel={closeModal}
  				onOk={closeModal} 
				width="80%"
				destroyOnClose
				bodyStyle={{ maxHeight: '78vh', overflowY: 'auto' }}
				title={modalTitle}
			>
				<Spin spinning={modalLoading}>
					<embed src={fileURL} width="100%" height={height}></embed>
				</Spin>
			</Modal>
		</>
	);
}